import { Divider } from 'antd';

import { trackTakeTourAction } from '../../../../analytics/mixpanel';
import CloseOutlined from '../../../../assets/common/CloseOutlined';
import AppCard2 from '../../../../CommonComponents/AppCards/AppCard2';
import AppButton from '../../../../CommonComponents/UI/AppButton/AppButton';
import { useTakeTour } from '../../hooks/useTakeTour';
import styles from './CustomTooltipComponent.module.scss';

const CustomTooltipComponent = (props) => {
  const { tourType, closeTour, totalSteps, currentStep } = useTakeTour();
  const { step, index } = props;

  const handleNext = () => {
    step.nextButtonProps.onClick();
  };

  const handleBack = () => {
    step.prevButtonProps.onClick();
  };

  const handleCloseTour = () => {
    trackTakeTourAction({
      takeTourType: tourType,
      action: 'Close button click',
      step: currentStep + 1,
    });
    closeTour('REMIND');
  };

  const handleSkip = () => {
    trackTakeTourAction({
      takeTourType: tourType,
      action: 'Do not show me again button click',
      step: currentStep + 1,
    });
    closeTour('DONE');
  };

  const handleFinishedTour = () => {
    trackTakeTourAction({ takeTourType: tourType, action: 'User has finished the tour' });
    closeTour('DONE');
  };

  const isFirstStep = index === 0;
  const isLastStep = index === totalSteps - 1;

  return (
    <AppCard2 className={styles.customTooltip} width={step.data?.styles?.width || '600px'}>
      <header className={styles.header}>
        <div className={styles.topRow}>
          <div className={styles.stepIndicator}>
            <span className={styles.stepText}>
              {index + 1}/{totalSteps}
            </span>
          </div>
          <div className={styles.titleContainer}>
            <h3 className={styles.title}>{step.title}</h3>
          </div>
          <AppButton
            className={styles.closeButton}
            type='text'
            onClick={handleCloseTour}
            icon={<CloseOutlined size={24} />}
          />
        </div>
      </header>
      <main className={styles.content}>{step.content}</main>
      {/* {step.description && (
          <p className={styles.description}>{step.description}</p>
        )} */}

      {/* {step.note && (
        <div className={styles.note}>
          <span className={styles.noteLabel}>Note:</span>
          <span className={styles.noteText}>{step.note}</span>
        </div>
      )} */}

      <Divider />
      <footer className={styles.footer}>
        <div className={styles.actions}>
          {!isFirstStep && (
            <AppButton
              className={styles.backButton}
              onClick={handleBack}
              // icon={<AngleLeft width="16" height="16" />}
              icon={
                <svg
                  className={styles.backIcon}
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M15 18L9 12L15 6'
                    stroke='currentColor'
                    strokeWidth='2'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </svg>
              }
            >
              Back
            </AppButton>
          )}
          <div />

          <AppButton
            onClick={isLastStep ? handleFinishedTour : handleNext}
            type='primary'
            icon={
              !isLastStep ? (
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='14'
                  height='14'
                  viewBox='0 0 14 14'
                  fill='none'
                >
                  <path
                    d='M5.25147 11.6665C5.10213 11.6665 4.95278 11.6094 4.83903 11.4956C4.61095 11.2675 4.61095 10.8988 4.83903 10.6707L8.50993 6.99984L4.83903 3.32894C4.61095 3.10086 4.61095 2.73215 4.83903 2.50407C5.06711 2.27599 5.43582 2.27599 5.6639 2.50407L9.74723 6.5874C9.97532 6.81549 9.97532 7.18419 9.74723 7.41227L5.6639 11.4956C5.55015 11.6094 5.4008 11.6665 5.25147 11.6665Z'
                    fill='white'
                  />
                </svg>
              ) : (
                false
              )
            }
            iconPosition='end'
          >
            {isLastStep ? 'Got it!' : 'Next'}
          </AppButton>
        </div>

        <div className={styles.skipOption} onClick={handleSkip}>
          <span className={styles.skipText}>Don't show me again</span>
        </div>
      </footer>
    </AppCard2>
  );
};

export default CustomTooltipComponent;
